import React, {Component} from 'react';

class StretchImage extends Component {
  shouldComponentUpdate(){
    return false;
  }

  render() {
    return(
      <div style={{position: 'absolute', top: this.props.top, left: this.props.left}}>
        <img alt="Stretched" style={{width: this.props.width, height: this.props.height}} src={this.props.src}/>
      </div>
    )
  }
}

export default StretchImage


// WEBPACK FOOTER //
// ./src/Components/General/StretchImage.js